// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1GRxd","label":"styles_label__2003B"};